/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:883afc61-7392-4471-924a-1e7d7ee7329e",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_Zb350HtIt",
    "aws_user_pools_web_client_id": "3objth91e8f0j7tbhs83vk9d52",
    "oauth": {
        "domain": "amplifycongitoauth-axb-fr.auth.eu-central-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_appsync_graphqlEndpoint": "https://t7qhgvtxwzc5td2jzz6usculy4.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_cloud_logic_custom": [
        {
            "name": "GetProductsRestAPI",
            "endpoint": "https://lr2wl9xu9e.execute-api.eu-central-1.amazonaws.com/master",
            "region": "eu-central-1"
        }
    ],
    "aws_content_delivery_bucket": "awsdrtool-hostingbucket-030818660024-eu-central-1-master",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://d2padkh0ngappf.cloudfront.net"
};


export default awsmobile;
